import { FEATURE_ENTITLEMENTS_STATUS } from 'constants/featureEntitlements';

interface IRehydratableUserState {
  isAuthenticated?: boolean | null;
  [key: string]: unknown;
}

export const applyAuthenticatedUserRehydrateDefaults = <
  T extends IRehydratableUserState
>(
  user: T
):
  | T
  | (T & {
      fetchingSettings: true;
      featureEntitlementsStatus: typeof FEATURE_ENTITLEMENTS_STATUS.IDLE;
    }) => {
  if (!user?.isAuthenticated) {
    return user;
  }

  return {
    ...user,
    fetchingSettings: true,
    featureEntitlementsStatus: FEATURE_ENTITLEMENTS_STATUS.IDLE
  };
};
